/*
 *
 *  Push Notifications codelab
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */

/* eslint-env browser, es6 */
/* eslint-disable no-unused-vars, no-console */
import axios from '@/axios'
import store from '@/store/store'
import { notifySuccess, notifyWarning } from '@/layouts/notifies'
import i18n from '@/i18n/i18n'
import app from '@/main'

const applicationServerPublicKey =
  'BGoF19ZA6462Bqn3DwRPAZylWu1SQfFHmn1BdA4FSo0uQUX4BNEOM2vC_rpXBDAHfTywGRIqnuGQWjMrQJWOOYs'

const ioToken = localStorage.getItem('ioToken') || sessionStorage.getItem('ioToken')

let isSubscribed = false
let swRegistration = null
function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding)
    // eslint-disable-next-line no-useless-escape
    .replace(/\-/g, '+')
    .replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}
function updateSubscriptionOnServer(subscription) {
  const payload = {
    subscription,
    ioToken
  }

  axios
    .post('pushes', payload)
    .then(function() {
      console.log('[Server] User IS subscribed.')
    })
    .catch(err => console.log('[Server] User is NOT subscribed with error', err))
}

function subscribeUser() {
  // Set the initial subscription value
  const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey)

  swRegistration.pushManager
    .subscribe({
      userVisibleOnly: true,
      applicationServerKey
    })
    .then(function(subscription) {
      isSubscribed = !(subscription === null)

      updateSubscriptionOnServer(subscription)

      if (isSubscribed) {
        console.log('[Browser] User IS subscribed.')
      } else {
        console.log('[Browser] User is NOT subscribed.')
      }
    })
    .catch(err => console.error(err))
}

export default {
  install(Vue, options) {
    if (store.state.auth.isUserLoggedIn()) {
      if ('serviceWorker' in navigator && 'PushManager' in window && 'Worker' in window) {
        navigator.serviceWorker
          .register('/sw.js')
          .then(function(swReg) {
            console.log('Service Worker is registered')

            swRegistration = swReg

            if (!('Notification' in window)) {
              this.$notifyWarning(this.$t('messages.push_notification_not_supported'))
            } else if (Notification.permission === 'granted') {
              subscribeUser()
            } else if (Notification.permission !== 'denied') {
              app.$vs.dialog({
                type: 'confirm',
                color: 'success',
                title: i18n.t('notices.notices'),
                text: i18n.t('messages.push_notification_required'),
                accept: () => {
                  Notification.requestPermission().then(function(permission) {
                    // If the user accepts, let's create a notification
                    if (permission === 'granted') {
                      notifySuccess(i18n.t('messages.push_notification_granted'))
                      subscribeUser()
                    }
                  })
                },
                acceptText: i18n.t('button.confirm'),
                cancelText: i18n.t('button.cancel')
              })
            }
          })
          .catch(function(error) {
            console.error(error)
          })

        const worker = new Worker('/sw.js')
        worker.postMessage(ioToken)
      } else {
        notifyWarning(i18n.t('messages.push_notification_not_supported'))
      }
    }
  }
}
